import { type RendererElement } from 'vue'

export type DoActionType =
  | 'before-enter'
  | 'after-enter'
  | 'before-leave'
  | 'after-leave'
type DoActionCallback = (str: DoActionType) => void

export const useSlide = (doAction: DoActionCallback) => {
  return {
    beforeEnter(el: RendererElement) {
      if (!el.dataset) el.dataset = {}
      el.dataset.oldPaddingTop = el.style.paddingTop
      el.dataset.oldPaddingBottom = el.style.paddingBottom
      el.style.maxHeight = 0
      el.style.paddingTop = 0
      el.style.paddingBottom = 0
      doAction('before-enter')
    },
    enter(el: RendererElement) {
      el.dataset.oldOverflow = el.style.overflow
      if (el.scrollHeight !== 0) {
        el.style.maxHeight = `${el.scrollHeight}px`
        el.style.paddingTop = el.dataset.oldPaddingTop
        el.style.paddingBottom = el.dataset.oldPaddingBottom
      } else {
        el.style.maxHeight = 0
        el.style.paddingTop = el.dataset.oldPaddingTop
        el.style.paddingBottom = el.dataset.oldPaddingBottom
      }
      el.style.overflow = 'hidden'
    },
    afterEnter(el: RendererElement) {
      el.style.maxHeight = ''
      el.style.overflow = el.dataset.oldOverflow
      doAction('after-enter')
    },
    beforeLeave(el: RendererElement) {
      if (!el.dataset) el.dataset = {}
      el.dataset.oldPaddingTop = el.style.paddingTop
      el.dataset.oldPaddingBottom = el.style.paddingBottom
      el.dataset.oldOverflow = el.style.overflow
      el.style.maxHeight = `${el.scrollHeight}px`
      el.style.overflow = 'hidden'
      doAction('before-leave')
    },
    leave(el: RendererElement) {
      if (el.scrollHeight !== 0) {
        el.style.maxHeight = 0
        el.style.paddingTop = 0
        el.style.paddingBottom = 0
      }
    },
    afterLeave(el: RendererElement) {
      el.style.maxHeight = ''
      el.style.overflow = el.dataset.oldOverflow
      el.style.paddingTop = el.dataset.oldPaddingTop
      el.style.paddingBottom = el.dataset.oldPaddingBottom
      doAction('after-leave')
    }
  }
}
